import { ReactNode, useId, useState } from 'react'
import { Button } from 'react-admin'
import { Box, Menu, MenuItem } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

type Props = {
  label: string
  variant?: 'text' | 'outlined' | 'contained'
  startIcon?: ReactNode
  options: { id: string; name: string }[]
  onClick?: (id: string) => void
  dataTestId?: string
}

const MenuButton = ({
  label,
  variant,
  startIcon,
  options,
  onClick,
  dataTestId
}: Props) => {
  const buttonId = useId()
  const menuId = useId()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClose = () => setAnchorEl(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget)

  const handleItemClick = (id: string) => {
    onClick?.(id)
    handleClose()
  }

  return (
    <Box>
      <Button
        id={buttonId}
        label={label}
        variant={variant}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={startIcon}
        data-testid={dataTestId}
      />
      <Menu
        id={menuId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': buttonId }}
      >
        {options.map(({ id, name }) => (
          <MenuItem key={id} onClick={() => handleItemClick(id)}>
            {name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}

export default MenuButton
